module.exports = __webpack_public_path__ + "static/media/login-image-entrepreneurs.024c16fb.png";